require('./bootstrap');

import $ from 'jquery';
window.$ = window.jQuery = $;
import "bootstrap/js/src/modal";
$(document).ready(function(){
  $('.sfilter').on("keyup", function() {
    var value = $(this).val().toLowerCase();
    $(".filterbody").filter(function() {
      $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    });
    if(!$(this).val()){
      $('.gfilterbody').show();
      $('.filterbody').hide();
  }
  else{
    $('.gfilterbody').hide();

  }
  });
});
$(window).bind('scroll', function () {
  if ($(window).scrollTop() > 100) {
    $('#headnav').addClass('fixed-top').removeClass('topnavbar');
    $('body').addClass('mt-5').removeClass('m-0');
  } else {
    $('#headnav').removeClass('fixed-top').addClass('topnavbar');
    $('body').removeClass('mt-5').addClass('m-0');
  }
});